import React from "react";

// Time constants
const TARGET_DATE = new Date("2034-01-01").getTime();
const SECOND_MS = 1000;
const MINUTE_MS = 60 * SECOND_MS;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;
const YEAR_MS = 365 * DAY_MS;

export default function ClimateClock() {
  const [str, setStr] = React.useState("calculating...");

  React.useEffect(() => {
    const tick = () => {
      const diff = TARGET_DATE - Date.now();
      const y = Math.floor(diff / YEAR_MS);
      const d = Math.floor((diff % YEAR_MS) / DAY_MS);
      const h = Math.floor((diff % DAY_MS) / HOUR_MS);
      const m = Math.floor((diff % HOUR_MS) / MINUTE_MS);
      const s = Math.floor((diff % MINUTE_MS) / SECOND_MS);
      setStr(`${y}y ${d}d ${h}h ${m}m ${s}s`);
    };
    tick();
    const id = setInterval(tick, SECOND_MS);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="climate" data-testid="climate-strip">
      <div>
        <p className="climate-label">Climate clock</p>
        <p className="climate-item">Time to 1.5°C: <strong data-testid="climate-countdown">{str}</strong></p>
      </div>
      <div><p className="climate-item">Atmospheric CO₂: <strong>424.3 ppm</strong></p></div>
      <div><p className="climate-item">Temperature rise: <strong>+1.2°C</strong> above pre-industrial</p></div>
      <div><p className="climate-item" style={{ fontStyle: "italic", color: "var(--sage)" }}>A different story is possible.</p></div>
    </div>
  );
}
